/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    common: {
      init: function() {
        // JavaScript to be fired on all pages
        var getWindowOptions = function() {
          var width = 500;
          var height = 350;
          var left = (window.innerWidth / 2) - (width / 2);
          var top = (window.innerHeight / 2) - (height / 2);

          return [
            'resizable,scrollbars,status',
            'height=' + height,
            'width=' + width,
            'left=' + left,
            'top=' + top,
          ].join();
        };

        
        var twitterBtn = document.querySelector('.twitter-share');
        if (twitterBtn) {
          var text = encodeURIComponent('Hey everyone, come & see how good I look!');
          var shareUrl = 'https://twitter.com/intent/tweet?url=' + location.href;
          twitterBtn.href = shareUrl; // 1

          twitterBtn.addEventListener('click', function(e) {
            e.preventDefault();
            var win = window.open(shareUrl, 'ShareOnTwitter', getWindowOptions());
            win.opener = null; // 2
          });
        }
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },
    // Home page
    home: {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      },
    },
    // About us page, note the change from about-us to about_us.
    about_us: {
      init: function() {
        // JavaScript to be fired on the about us page
      },
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(
        i,
        classnm
      ) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    },
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.

jQuery('.hamburger').click(() => {
  var button = jQuery('.hamburger');
  var target = button.data('target');

  button.toggleClass('is-active');
  jQuery(target).toggleClass('is-active');
});


jQuery(function($){
  const url = new URL(window.location.href);
  const status = url.searchParams.get("status");

  if (status) {
    switch(status) {
      case 'declined':
        jQuery(".wpcf7").prepend('<p class="message-error-pay">Your payment has been declined.</p>');
        break
      case 'error':
        jQuery(".wpcf7").prepend('<p class="message-error-pay">An error occurred while completing the payment.</p>');
        break
      case 'cancelled':
        jQuery(".wpcf7").prepend('<p class="message-error-pay">Your payment has been canceled.</p>');
        break
      default:
    }
  }

  $( document ).ready(function() {
    jQuery('header select[name="support_type"]').prop('selectedIndex', 0).selectric('refresh');
  });

  jQuery('header select[name="support_type"]').selectric({
    openOnHover: true,
    nativeOnMobile: false,
    hoverIntentTimeout: 300,
    optionsItemBuilder: function(itemData, element, index) {
      if (element.val().length && itemData.text)
        return '<a href="'+element.val()+'" data-index="'+index+'" style="background-image: '+$(itemData.element).css('background-image').replaceAll('"', '')+'" class="">'+itemData.text+'</a>';
    },
    onClose: function(itemData, element, index) {
      console.log(itemData, element, index)
    },
    onChange: function(data) {
      window.location.href = $(data).val()
      jQuery('header select[name="support_type"]').prop('selectedIndex', 0).selectric('refresh');
    },
  });

  $(document).on('click', '.header-main .selectric .label', function() {
    jQuery('header select[name="support_type"]').selectric('open')
    if ($(this).parents('.selectric-wrapper').hasClass('selectric-open'))
      window.location = $('header .selectric-scroll li[data-index="0"] a').attr('href');
  })

  //Show and hide search field
  // $('.show-search').click(function(){
  //   $('.header-search form').toggleClass('active');
  //   $(this).toggleClass('active');
  //   return false;
  // })
  
  $('.hide-search').click(function(){
    $('.header-search form').toggleClass('active');
    $('.show-search').toggleClass('active');
    return false;
  })

  $('[name="sort"]').change(function() {
    $('.search-form').submit();
  })

  // open video player
  $('.main-section-video').click(function(e){
    if (e.target.nodeName == 'VIDEO')
      return false;
    let _th = $(this), 
    id = _th.data('id');
    type = _th.data('type');
    if (type == 'vimeo') {
      _th.html('<iframe src="https://player.vimeo.com/video/'+id+'?autoplay=1&loop=1&autopause=0" width="'+_th.width()+'" height="'+_th.outerHeight()+'" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>')
    } else if (type == 'youtube') {
      _th.html('<iframe src="https://www.youtube.com/embed/'+id+'?autoplay=1" width="'+_th.width()+'" height="'+_th.outerHeight()+'" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>')
    } else if (type == 'host') {
      _th.html('<video controls autoplay><source src="'+id+'" type="video/mp4"></video>');
    }
    _th.addClass('playing');
    return false;
  })

  //open common menu
  $('.sandwich').click(function(){
    $('.common-menu').addClass('active')
  })
  //mobile menu 
  $('.main-menu > li').click(function(){
    if ($(window).width() < 480) {
      $(this).toggleClass('active')
      $(this).find('.sub-menu').slideToggle();
    }
  })


  $('.close-menu').click(function(){
    $('.common-menu').removeClass('active')
    return false;
  })

  //FAQ toggler
  $('.faq-title').click(function(){
    $(this).toggleClass('active');
    $(this).next().slideToggle();
    return false;
  })

  jQuery('.email-page').magnificPopup();

  $('#mail-popup form').submit(function() {
    var th = $(this);
    $.ajax({
      type: 'POST',
      url: ajaxurl + "?action=email_post",
      data: th.serialize(),
      success: function(data) {
        $('#info-popup .popup-title').html(data.message);
        jQuery.magnificPopup.open({
          items: {
            src: '#info-popup',
            type: 'inline'
          }
        });
      }
    });
    return false
  });

  if ($(window).width() < 567) {

    $('.the-content figure ~ p').each(function() {
      if ($(this).html() == '&nbsp;') {
        $(this).remove();
      }
    })
  }

  //main full-width slider
  jQuery('.main-slider').slick({
    arrows: false,
    dots: true
  });

  $('.main-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    $('video').each(function(){
      $(this).parent().removeClass('playing')
      this.pause();
    });
  });

  //play/stop video sliderы
  $('.main-slider-item-video, .gallery-img.gallery-video').click(function(){
    var mediaVideo = $(this).find('video').get(0);
    $(this).toggleClass('playing');
    if (mediaVideo.paused)
      mediaVideo.play();
    else
      mediaVideo.pause();
    return false;
  })

  $('.print-content').click(function() {
    $('body').addClass('printable');
    window.print();
    $('body').removeClass('printable');
    return false;
  })

  jQuery('.mail-content').magnificPopup();

  $('#show-more-events').click(function() {
    $('.event-item.hidden').each(function(index) {
      if (index < 20)
        $(this).removeClass('hidden')
    })
    if ($('.event-item.hidden').length == 0)
      $(this).hide();
    return false;
  })

})

jQuery('input[type=radio][name=your-amount]').change(function() {
  if (this.value == 'Observatör (0 kr)') {
    jQuery('.your-payment').parent().hide();
  } else {
    jQuery('.your-payment').parent().show();
  }
})

function _get_order_status(payment_id) {
  jQuery.ajax({
    type: 'POST',
    url: ajaxurl + "?action=get_order_status&payment_id=" + payment_id,
    success: function(data) {
      if (data.data.payment_method == 'Swish' && data.data.status == 'PAID') {
        window.location.href = data.data.redirect_url;
      }

      setTimeout(() => {
        _get_order_status(payment_id);
      }, 10000);
    }
  });
}

document.addEventListener( 'wpcf7submit', function( event ) {
  if (event.detail.apiResponse.without_pay) {
    jQuery('.wpcf7-response-output').remove();
    jQuery('#info-popup .popup-title').html('Tack för din anmälan till kongressen! Bekräftelse har skickats till er e-postadress. <br>Var vänligen kolla i er skräpinkorg om ni inte ha fått bekräftelse.');
    jQuery.magnificPopup.open({
      items: {
        src: '#info-popup',
        type: 'inline'
      }
    });
    return;
  }
  if (event.detail.apiResponse.redirect_uri) {
    window.location.href = event.detail.apiResponse.redirect_uri;
  }

  if (event.detail.apiResponse.swish) {
    let form_text = '';

    switch (event.detail.apiResponse.swish_status) {
      case '001':
        _get_order_status(event.detail.apiResponse.payment_id);
        form_text = 'Öppna appen och slutför betalningen';
        break;
      case '002':
        form_text = 'Du har redan skapat en betalningsförfrågan';
        break;
      case '003':
        form_text = 'Du är inte registrerad hos Swish';
        break;
      default:
        form_text = 'Betalningsbegäran skickades'
    }

    jQuery('.wpcf7-response-output').remove();
    jQuery('#info-popup .popup-title').html(form_text);
    jQuery.magnificPopup.open({
      items: {
        src: '#info-popup',
        type: 'inline'
      }
    });
  }
}, false );


// WEBPACK FOOTER //
// ./assets/scripts/main.js